import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import DomainImage from '../../../../../components/DomainImage';

/**
 * BigQuery returns DATE columns as `{ value: 'YYYY-MM-DD' }`, while the cached
 * report payload may already hold a plain string — accept both.
 */
export const getLastSeen = (data) => (typeof data === 'object' ? data?.value : data) || '';

export const COLUMNS = (t) => [
    {
        label: t('ai_tracking.keyword_detail.facts.columns.fact'),
        key: 'fact',
        data: 'fact',
        Component: Cell,
        colSpan: 2,
        cellSize: 'minmax(300px, 3fr)',
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <span className="wrap-text">{data}</span>;
        },
    },
    {
        label: t('ai_tracking.keyword_detail.facts.columns.brand'),
        key: 'brand',
        data: 'brand',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <div className="wrap-text">{data}</div>;
        },
    },
    {
        label: t('ai_tracking.keyword_detail.facts.columns.domain'),
        key: 'domain',
        data: 'domain',
        Component: Cell,
        cellSize: 'minmax(180px, 1.5fr)',
        sortType: 'string',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.domain ?? '';
            if (!item.domain) return '-';
            return (
                <div>
                    <div className="wrap-text d-flex align-items-center">
                        <DomainImage domain_name={item.domain} className="domain_img" />
                        <span>{item.domain}</span>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.facts.columns.score'),
        key: 'sumScore',
        data: 'sumScore',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return numeral(data).format('0,0.[00]');
        },
    },
    {
        label: t('ai_tracking.keyword_detail.facts.columns.lastSeen'),
        key: 'lastSeen',
        data: 'lastSeen',
        Component: Cell,
        sortType: (array) =>
            array.sort(
                (a, b) => new Date(getLastSeen(a.lastSeen)) - new Date(getLastSeen(b.lastSeen)),
            ),
        renderCell: ({ data }) => getLastSeen(data) || '-',
    },
];
